import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/hooks/useAuth';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const LoginPage = lazy(() => import('@/modules/auth/pages/LoginPage'));
const PreCadastroListPage = lazy(() => import('@/modules/pre-cadastro/pages/PreCadastroListPage'));
const CadastroPage = lazy(() => import('@/modules/cadastro-publico/pages/CadastroPage'));
const NotFoundPage = lazy(() => import('@/pages/NotFound'));

function LoadingFallback() {
  return <div className="flex h-screen items-center justify-center">Carregando...</div>;
}

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Navigate to="/admin" replace />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/cadastro" element={<CadastroPage />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/admin" element={<PreCadastroListPage />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </AuthProvider>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
